import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthComponent } from './auth/auth.component';

const routes: Routes = [
  {
    path: 'subjekt',
    loadChildren: () => import('./supplier/supplier.module').then(mod => mod.SupplierModule),
  },
  {
    path: 'sablony',
    loadChildren: () => import('./template/template.module').then(mod => mod.TemplateModule),
  },
  {
    path: 'zakazka',
    loadChildren: () => import('./order/order.module').then(mod => mod.OrderModule),
  },
  {
    path: 'fakturace',
    loadChildren: () => import('./invoicing/invoicing.module').then(mod => mod.InvoicingModule),
  },
  {
    path: 'auth',
    component: AuthComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
